import { useNavigate } from "react-router-dom"
import styled from "styled-components"

import { Button } from "components/form/Button"

const ErrorBoundaryWrapper = styled.section`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
`

const ErrorBoundary = styled.div`
  background: #fff;
  border-radius: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 600px;
  width: 100%;
  padding: 60px 30px 30px;
`

const ErrorBoundaryMessage = styled.h2`
  font-size: 1.5rem;
  font-family: "Inter";
  text-align: center;
  margin-bottom: 50px;

  span {
    display: block;
    font-size: 70px;
  }
`

const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const NotFound = () => {
  const navigate = useNavigate()

  const goBack = () => {
    navigate(-1)
  }

  const goHome = () => {
    navigate("/")
  }

  return (
    <ErrorBoundaryWrapper>
      <ErrorBoundary>
        <ErrorBoundaryMessage>
          <span>404</span>
          This page doesn&#39;t exist.
        </ErrorBoundaryMessage>
        <ButtonsWrapper>
          <Button onClick={goBack} size="halfWidth" color="white">
            Go Back
          </Button>
          <Button onClick={goHome} size="halfWidth" color="colored">
            Home page
          </Button>
        </ButtonsWrapper>
      </ErrorBoundary>
    </ErrorBoundaryWrapper>
  )
}
